module.exports = __webpack_public_path__ + "static/images/pricing-empty.6239cdf1bb745eb2e6de283474f41676.svg";